const MIN_PASSWORD_LENGTH = 10;
const MAX_PASSWORD_LENGTH = 128;

const normalizePassword = (password) => (typeof password === "string" ? password : "");

const strengthChecks = [
  (password) => password.length >= MIN_PASSWORD_LENGTH,
  (password) => /[a-z]/.test(password),
  (password) => /[A-Z]/.test(password),
  (password) => /\d/.test(password),
  (password) => /[^A-Za-z0-9]/.test(password)
];

export const isPasswordStrong = (password) => {
  const len = normalizePassword(password).length;
  return len >= MIN_PASSWORD_LENGTH && len <= MAX_PASSWORD_LENGTH;
};

export const isPasswordTooLong = (password) => normalizePassword(password).length > MAX_PASSWORD_LENGTH;

export const getPasswordStrength = (password) => {
  const value = normalizePassword(password);

  if (!value) {
    return {
      score: 0,
      percent: 0,
      level: "empty",
      colorScheme: "gray"
    };
  }

  const score = strengthChecks.reduce((acc, check) => (check(value) ? acc + 1 : acc), 0);
  const percent = (score / strengthChecks.length) * 100;

  let level = "very_weak";
  if (score <= 1) {
    level = "very_weak";
  } else if (score === 2) {
    level = "weak";
  } else if (score === 3) {
    level = "medium";
  } else if (score === 4) {
    level = "strong";
  } else {
    level = "very_strong";
  }

  const colorMap = {
    empty: "gray",
    very_weak: "red",
    weak: "orange",
    medium: "yellow",
    strong: "green",
    very_strong: "teal"
  };

  return {
    score,
    percent,
    level,
    colorScheme: colorMap[level] || "gray"
  };
};

export { MIN_PASSWORD_LENGTH, MAX_PASSWORD_LENGTH };
